import React, { FunctionComponent } from "react";
import Container from "../../atoms/Container/Container";
import BreedDetailHeader, { ITraitType } from "../../molecules/BreedDetailHeader";
import BreedDetailSubheader from "../../molecules/BreedDetailSubheader";
import Calculator from "../../molecules/Calculator";
import { Document } from "@contentful/rich-text-types/dist/types/types";
import { RichTextContent } from "@/src/components/v2/RichTextContent/RichTextContent";

export interface BreedTrait {
    title: string;
    affectsPercentage?: string;
    content: Document;
    vetBillCost: number;
}

export interface BreedTraitDetailProps {
    type: ITraitType;
    starCount: number;
    traits: BreedTrait[];
    specie: string;
}

const BreedTraitDetail: FunctionComponent<BreedTraitDetailProps> = props => {
    function renderTrait(trait: BreedTrait, index: number) {
        return (
            <div key={trait.title + index} className={"mt-4 border-none border-border-dark md:mb-6 md:border-b md:border-solid md:pb-6 lg:mb-10 lg:mt-8 lg:pb-10"}>
                <div className="flex flex-row flex-wrap justify-center gap-8">
                    <div className="flex-1">
                        <BreedDetailSubheader title={trait.title} subtitle={props.type} fact={trait.affectsPercentage} specie={props.specie} />
                        <div className="breedTraits mt-4 lg:mt-8">
                            <RichTextContent content={trait.content} demoteHeading1 />
                        </div>
                    </div>
                    <div>
                        <Calculator total={trait.vetBillCost} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Container>
            <BreedDetailHeader trait={props.type} starCount={props.starCount as any} />
            {props.traits.map(renderTrait)}
        </Container>
    );
};

export default BreedTraitDetail;
